<template>
  <v-app :style="[cssVars, { background: $vuetify.theme.themes['light'].background }]">

    <Navbar
      :links="computedLinks"
      :isSmAndDown="isSmAndDown"
      :isXs="isXs"
      @openPersonalCard="showPersonalCard = true"
      @openInstructionsDialog="instructionsDialog = true"
      @openHelpDialog="helpDialog = true"
      @openContactsDialog="contactsDialog = true"
    />

    <LeftMenu
      v-if="!isSmAndDown && computedLinks.length"
      :links="computedLinks"
    />

    <PersonalData
      :dialog="showPersonalCard"
      @close="showPersonalCard = false"
    />

    <Contacts
      :dialog="contactsDialog"
      @closeContactsDialog="contactsDialog = false"
    />

    <HelpDialog
      :dialog="helpDialog"
      @closeHelpDialog="helpDialog = false"
    />

    <v-main class="background main mr-3 ml-3" :class="{'mobile': isSmAndDown}">
      <router-view :isSmAndDown="isSmAndDown"/>
    </v-main>

    <v-footer padless class="background footer">
      <v-col class="caption accent--text px-4" cols="12">
        © {{ new Date().getFullYear() }}, Заявления на восстановление и перевод
      </v-col>
    </v-footer>

  </v-app>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Navbar from '@/components/ui/Navbar'
import PersonalData from '@/components/zvp/personal-data/Index'
import LeftMenu from '@/components/ui/LeftMenu'
import HelpDialog from '@/components/dialogs/Help'
import Contacts from '@/components/dialogs/ContactsDialog'

export default {
  name: 'App',

  components: {
    Navbar,
    Contacts,
    PersonalData,
    LeftMenu,
    HelpDialog
  },

  data: () => ({
    isSmAndDown: false,
    isXs: false,

    helpDialog: false,
    showPersonalCard: false,
    contactsDialog: false,

    links: [
      {
        icon: "mdi-file-document-multiple-outline",
        text: "Обработка заявлений",
        route: "/zvp/applications",
        allowRoles: ['ROLE_ADMIN', 'ROLE_CURATOR']
      },
      {
        icon: "mdi-bell-ring",
        text: "Управление уведомлениями",
        route: "/zvp/notification",
        allowRoles: ['ROLE_ADMIN', 'ROLE_CURATOR']
      },
      {
        icon: "mdi-account-multiple",
        text: "Вакантные места",
        route: "/zvp/vacancies",
        allowRoles: ['ROLE_ADMIN', 'ROLE_CURATOR']
      },
      {
        icon: "mdi-poll",
        text: "Назначение конкурса",
        route: "/zvp/contest-page",
        allowRoles: ['ROLE_ADMIN', 'ROLE_CURATOR']
      },
      {
        icon: "mdi-text-box-multiple-outline",
        text: "Результаты тестирования",
        route: "/zvp/test-results",
        allowRoles: ['ROLE_ADMIN', 'ROLE_CURATOR']
      },
      {
        icon: "mdi-file-cog",
        text: "Настройки документации",
        route: "/zvp/documentation-setup",
        allowRoles: ['ROLE_ADMIN', 'ROLE_CURATOR']
      },
      {
        icon: "mdi-calendar-multiselect",
        text: "Управление сроками",
        route: "/zvp/deadlines",
        allowRoles: ['ROLE_ADMIN', 'ROLE_CURATOR']
      },
      {
        icon: "mdi-calendar-clock",  
        text: "Учебные периоды",
        route: "/zvp/submission-session",
        allowRoles: ['ROLE_ADMIN', 'ROLE_CURATOR']
      }
      // {
      //   icon: "mdi-cog",
      //   text: "Настройки системы",
      //   route: "/zvp/system",
      //   allowRoles: ['ROLE_ADMIN']
      // },
    ]
  }),

  mounted() {
    this.onResize()
    window.addEventListener("resize", this.onResize)
  },

  destroyed() {
    window.removeEventListener("resize", this.onResize)
  },

  computed: {
    ...mapState('system', ['techMessageHeight', 'dataLoaded']),
    ...mapGetters('user', ['userId', 'allUserRoles']),
    ...mapState('personalData', ['personalData']),

    computedLinks() {
      if (!this.userId) return []
      return this.links.filter(link => link.allowRoles.some(role => this.allUserRoles.includes(role)))
    },

    cssVars() {
      return {
        '--tech-message-height': this.techMessageHeight + 'px'
      }
    }
  },

  methods: {
    onResize() {
      this.isSmAndDown = window.innerWidth < 960
      this.isXs = window.innerWidth < 620
    },
  },

  watch: {
    'dataLoaded': {
      immediate: true,
      handler(value) {
        if (value) {
          if (!this.personalData.id) this.showPersonalCard = true
        }
      }
    }
  }
}
</script>

<style>
.el-loading-mask {
  border-radius: 20px;
}

.v-dialog {
  border-radius: 20px !important;
}

.required::after {
  content: ' *';
  color: #E60000;
}

html {
  overflow-y: auto !important;
}

body {
  color: #37474f;
  background-color: rgb(232, 234, 246);
}

body button {
  text-transform: none !important;
}

.custom-tabs-arrows .v-slide-group__prev {
  min-width: 28px !important;
  justify-content: left !important;
  flex: 0 1 32px !important;
}

.custom-tabs-arrows .v-slide-group__next {
  min-width: 28px !important;
  justify-content: left !important;
  flex: 0 1 32px !important;
}

.custom-tabs-arrows .v-slide-group__next i {
  margin-left: 6px;
}

.main {
  margin-top: calc(100px + var(--tech-message-height))
}

.footer {
  z-index: 1;
}

.toast.toast-warning {
  background-color: #FF6F00 !important;
}
.toast.toast-warning .toast-title {
  color: #FF6F00 !important;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
  height: 7px;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: #B0B0B0;
  -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
}

.emptyCard-enter-active {
  transition: opacity .2s;
}

.emptyCard-leave-active {
  transition: opacity .2s;
}

.emptyCard-enter, .emptyCard-leave-to {
  opacity: 0;
}

.btn-color {
  background-color: rgb(232, 234, 246) !important;
  color: #37474f !important;
}

.alert-flex {
  display: flex !important;
  justify-content: space-between !important;
}
</style>
